export let BI_SOURCES = /*#__PURE__*/function (BI_SOURCES) {
  BI_SOURCES[BI_SOURCES["VOD_SRC_ID"] = 71] = "VOD_SRC_ID";
  return BI_SOURCES;
}({});
//# sourceMappingURL=sources.js.map